//Renny Gong is in his fourth year at Columbia University. He loves to take things off the street.
import { Link } from "react-router-dom";
import { useState } from "react";

export const Profile = ({ isMobile }: { isMobile: boolean }) => {
  const [clicked, setClicked] = useState(false);
  const buttonStyle =
    "bg-black text-white flex items-center justify-center font-anybody text-sm hover:text-black hover:bg-white transition";
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div
        className={`flex gap-8 h-[500px] ${isMobile ? "overflow-hidden" : ""}`}
      >
        <img
          src={`./images/profilePicture/profile.jpg`}
          className="object-cover shrink-0 group-hover:opacity-20 transition"
          alt={"Renny drinking a Large Sangria"}
          onClick={() => setClicked(!clicked)}
        />
        {isMobile && clicked ? (
          <div className="absolute bottom-0 left-0 right-0 top-0">
            <div className="absolute bottom-32 bg-white w-72 font-helvetica italic h-fit flex grow-0 items-center text-xl">
              <div className="flex flex-col gap-4">
                <div>
                  Renny Gong is an MFA candidate in Fiction at the Iowa Writers'
                  Workshop. Also, he teaches Creative Writing at the University
                  of Iowa.
                </div>
                <div>
                  <div>twitter: @rennyxgong</div>
                  <div>instagram: @renny.reviews</div>
                </div>
              </div>
            </div>
            <div className="absolute bottom-0 flex flex-row w-full justify-between ">
              <Link className={`w-16 h-8 ${buttonStyle}`} to="/">
                home
              </Link>
              <Link className={`w-16 h-8 ${buttonStyle}`} to="/work">
                work
              </Link>
            </div>
          </div>
        ) : (
          <div className="w-64 font-helvetica italic h-full flex grow-0 items-center text-xl">
            <div className="flex flex-col gap-4">
              <div>
                Renny Gong is an MFA candidate in Fiction at the Iowa Writers'
                Workshop. Also, he teaches Creative Writing at the University of
                Iowa.
            </div>
                <div>
                <div>twitter: @rennyxgong</div>
                <div>instagram: @renny.reviews</div>
              </div>
              <div className="flex flex-row gap-20">
                <Link className={`w-16 h-8 ${buttonStyle}`} to="/">
                  home
                </Link>
                <Link className={`w-16 h-8 ${buttonStyle}`} to="/work">
                  work
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
